import React from 'react';
import {
  Buildings, CheckCircle, CurrencyDollar, TrendUp,
} from '@phosphor-icons/react';
import { Card, CardContent } from '../../components/ui/card';

const KpiCard = ({ label, value, Icon, gradientFrom, valueColor, iconBg, iconColor }) => (
  <Card className={`border-slate-200 bg-gradient-to-br ${gradientFrom} to-white`}>
    <CardContent className="pt-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wide">{label}</p>
          <p className={`text-2xl font-bold ${valueColor}`}>{value}</p>
        </div>
        <div className={`p-3 ${iconBg} rounded-full`}>
          <Icon size={24} className={iconColor} />
        </div>
      </div>
    </CardContent>
  </Card>
);

export const CrossAgencyKpiCards = ({ totals, activeAgencies }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    <KpiCard
      label="Total Billed"
      value={`$${totals.totalBilled.toLocaleString()}`}
      Icon={CurrencyDollar}
      gradientFrom="from-indigo-50"
      valueColor="text-indigo-900"
      iconBg="bg-indigo-100"
      iconColor="text-indigo-600"
    />
    <KpiCard
      label="Total Collected"
      value={`$${totals.totalCollected.toLocaleString()}`}
      Icon={CheckCircle}
      gradientFrom="from-green-50"
      valueColor="text-green-700"
      iconBg="bg-green-100"
      iconColor="text-green-600"
    />
    <KpiCard
      label="Collection Rate"
      value={`${totals.overallRate}%`}
      Icon={TrendUp}
      gradientFrom="from-blue-50"
      valueColor="text-blue-700"
      iconBg="bg-blue-100"
      iconColor="text-blue-600"
    />
    <KpiCard
      label="Active Agencies"
      value={activeAgencies}
      Icon={Buildings}
      gradientFrom="from-purple-50"
      valueColor="text-purple-700"
      iconBg="bg-purple-100"
      iconColor="text-purple-600"
    />
  </div>
);

export default CrossAgencyKpiCards;
